import { ChainName } from '@ui/types/chain';
import BigNumber from 'bignumber.js';

export const DEGEN_MIN_LEVERAGE = 500;
export const DEGEN_LEVERAGE_ARRAY = [
  {
    sliderValue: 130,
    value: DEGEN_MIN_LEVERAGE,
  },
  {
    sliderValue: 150,
    value: 750,
  },
  {
    sliderValue: 170,
    value: 1001,
  },
];

export const DEGEN_ENTRY_LP_AMOUNT_PER_CHAIN: Record<ChainName, number> = {
  [ChainName.MONAD]: 200,
  [ChainName.MONAD_TESTNET]: 1000,
};
export const DEFAULT_LEVERAGE = 10;
export const NORMAL_MIN_LEVERAGE = 1.1;
export const DEFAULT_SLIPPAGE = 0.01; // 1%
export const SLIPPAGE_ARRAY = [0.005, 0.006, 0.007, 0.008, 0.009, 0.01];
export const MAX_SLIPPAGE = SLIPPAGE_ARRAY[SLIPPAGE_ARRAY.length - 1];
export const MIN_SLIPPAGE = SLIPPAGE_ARRAY[0];

export const DEFAULT_UNDEFINED_NUMBER_DISPLAY = '-';
export const DEFAULT_PERCENTAGE_UNDEFINED_NUMBER_DISPLAY = `${DEFAULT_UNDEFINED_NUMBER_DISPLAY}${DEFAULT_UNDEFINED_NUMBER_DISPLAY}%`;
/**
 * use it sparingly, adding it to high level code (display, calculation) will add cognitive load
 */
export const BASIS_POINTS_DIVISOR = 10000;

export const DEGEN_FEE_CONFIG_POINTS_DIVISOR = 1e5;

/**
 * according to APX, for positionSize if reach current leverageMargin 's max leverage, will need to deduct the 0.5%, to avoid reach max leverage error
 */
export const POSITION_BUFFER_THRESHOLD = 0.005;

/**
 * a small value to place hold contract call params for estimation purpose, reduce redundant gas query call
 * it is under the assumption that in most cases gas fee does not change according to param change
 */
export const EST_INPUT_AMOUNT = new BigNumber(0.001);
/**
 * MAX OI check slippage
 */
export const MAX_OI_CHECK_BUFFER = 0.005;
export const MIN_NOTIONAL_CHECK_BUFFER = 0.005;
export const LP_SLIPPAGE = 0.005;

export const APR_DISPLAY_DECIMALS = 2;

export const LP_INITIAL_PRICE = 1;

export const DEFAULT_SPREAD = 0.0001; // 0.01%
